import React from "react";
import Select from "react-select";
import { sweetalert } from "../../App";
import { isBlank, isOnlyWhitespace } from "../../util/ValidationUtil";
import { buildRow, getBoolSelectOptions, getBoolSelectVal } from "../../util/FormatUtil";
import { isEmptyObject } from "jquery";
import { Category } from "../../types/Category";

interface CategoryManagementModalState {
  selectedCategory: Category;
}
interface CategoryManagementModalProps {
  selectedCategory: Category;
  onSubmit?;
}

export class CategoryManagementModal extends React.Component<CategoryManagementModalProps, CategoryManagementModalState> {
  public static ID = "categorymanagement";

  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: {
        ID: null,
        Name: "",
        IsActive: 1,
      } as Category,
    };
  }

  componentWillReceiveProps(nextProps: Readonly<CategoryManagementModalProps>) {
    if (nextProps.selectedCategory && !isEmptyObject(nextProps.selectedCategory)) {
      let category = nextProps.selectedCategory;
      this.setState({
        selectedCategory: {
          ID: category.ID ? category.ID : null,
          Name: category.Name ? category.Name : "",
          IsActive: (category.IsActive || category.IsActive === 0) ? category.IsActive : 1,
        } as Category,
      });
    }
  }

  render() {
    return (
      <div className="modal fade form_modal" id={CategoryManagementModal.ID} tabIndex={-1} role="dialog"
        aria-labelledby="category_modal_label"
        aria-hidden="true">
        <div className="modal-dialog modal-lg modal-xl" role="document">
          <div className="modal-content">
            <div className="container-fluid">
              <div className="modal-header">
                <h5 className="modal-title" id="category_modal_label">Category Management</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {buildRow("Name",
                  <input className={"form-control"}
                    maxLength={255}
                    autoComplete={"off"}
                    type={"search"}
                    name={"Name"}
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        selectedCategory: { ...prevState.selectedCategory, Name: e.target.value }
                      }))
                    }}
                    value={this.state.selectedCategory.Name}
                  />,
                  'The category name shown when grouping FAQs',
                  true
                )}
                {buildRow("Is Active?",
                  <Select
                    isSearchable={true}
                    placeholder={"Please Select..."}
                    noOptionsMessage={() => "No option"}
                    value={getBoolSelectVal(this.state.selectedCategory.IsActive)}
                    onChange={(e) => this.setState((prevState) => ({
                      selectedCategory: { ...prevState.selectedCategory, IsActive: e.value ? 1 : 0 }
                    }))}
                    className={"state_select"}
                    options={getBoolSelectOptions()}
                  />,
                  'Disabling a category hides its FAQs from users',
                  true
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary" onClick={() => {
                  if (isBlank(this.state.selectedCategory.Name) || isOnlyWhitespace(this.state.selectedCategory.Name)) {
                    return sweetalert.fire("Attention", "Category name cannot be empty.", "error")
                  }
                  this.props.onSubmit(this.state.selectedCategory);
                }}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
